'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getServerTimeOffsetFailed = exports.getServerTimeOffsetSucceeded = exports.getServerTimeOffset = exports.pubNubClientConnected = exports.forceClientOffline = exports.conversationsClientReady = undefined;

var _reduxActions = require('redux-actions');

var _ActionTypes = require('conversations-core/constants/ActionTypes');

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var conversationsClientReady = exports.conversationsClientReady = (0, _reduxActions.createAction)(_ActionTypes2.default.CONVERSATIONS_CLIENT_READY);

var forceClientOffline = exports.forceClientOffline = (0, _reduxActions.createAction)(_ActionTypes2.default.FORCE_CLIENT_OFFLINE);

var pubNubClientConnected = exports.pubNubClientConnected = (0, _reduxActions.createAction)(_ActionTypes2.default.PUBNUB_CLIENT_CONNECTED);

var getServerTimeOffset = exports.getServerTimeOffset = (0, _reduxActions.createAction)(_ActionTypes2.default.GET_SERVER_TIME_OFFSET);

var getServerTimeOffsetSucceeded = exports.getServerTimeOffsetSucceeded = (0, _reduxActions.createAction)(_ActionTypes2.default.GET_SERVER_TIME_OFFSET_SUCCEEDED);

var getServerTimeOffsetFailed = exports.getServerTimeOffsetFailed = (0, _reduxActions.createAction)(_ActionTypes2.default.GET_SERVER_TIME_OFFSET_FAILED);


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/actions/ClientActions.js
// module id = 196
// module chunks = 0